import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.element.dataset.turboFeedbackFocused === "true") return

    this.focusFrame = window.requestAnimationFrame(() => {
      this.focusFrame = null
      if (!this.element.isConnected || this.element.dataset.turboFeedbackFocused === "true") return

      this.element.dataset.turboFeedbackFocused = "true"
      this.element.focus({ preventScroll: true })
    })
  }

  disconnect() {
    if (this.focusFrame === null || this.focusFrame === undefined) return

    window.cancelAnimationFrame(this.focusFrame)
    this.focusFrame = null
  }
}
